const e = "Aparthotéis", s = "Apartamentos", o = "Negócios", t = "Parques de Campismo", a = "Casal", i = "Família", n = "Amigos", r = "Albergues", m = "Hotéis", l = "Resorts", c = "Restaurantes", d = {
  "{num} reviews": "{num} avaliações",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} em {location}",
  "All languages": "Todos os idiomas",
  "All traveler types": "Todos os tipos de viajantes",
  Aparthotels: e,
  Apartments: s,
  "Arrow icon": "Ícone de seta",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "baseado em {number} avaliações",
  Business: o,
  Campsites: t,
  Couple: a,
  Family: i,
  Friend: n,
  "Highlighted reviews": "Comentários em destaque",
  Hostels: r,
  Hotels: m,
  "Information icon": "Ícone de informação",
  "No reviews found": "Não foram encontradas comentários",
  "Pet-friendly": "Amigo dos animais",
  "Posted on {reviewer}": "Publicado em {reviewer}",
  "Read Reviews": "Ver comentários",
  Resorts: l,
  Restaurants: c,
  "Review Summary": "Resumo das avaliações",
  "Reviews by Source": "Avaliações por fonte"
};
export {
  e as Aparthotels,
  s as Apartments,
  o as Business,
  t as Campsites,
  a as Couple,
  i as Family,
  n as Friend,
  r as Hostels,
  m as Hotels,
  l as Resorts,
  c as Restaurants,
  d as default
};
//# sourceMappingURL=pt.3DHLfYox.js.map
